/**
 * LUNE — Moteur de recommandation produits (vanilla JS).
 * Score les décors du catalogue (injecté depuis Shopify via Liquid, voir
 * sections/lune-widget.liquid) selon les réponses du questionnaire.
 * Ne fabrique jamais de caractéristique produit : la "raison" affichée est
 * assemblée uniquement à partir des critères réellement renseignés sur le
 * produit (metafields lune.room / lune.style / lune.colors / lune.intensity)
 * et effectivement demandés par le client — jamais de texte inventé sur le
 * rendu visuel du décor.
 */
window.Lune = window.Lune || {};

Lune.Recommend = (function () {
  'use strict';

  var WEIGHTS = { style: 4, room: 3, colors: 2, intensity: 2 };

  function scoreProduct(product, answers) {
    var s = 0;
    var matched = { room: [], style: [], colors: [], intensity: false };

    if (answers.style && product.style) {
      answers.style.forEach(function (v) {
        if (product.style.indexOf(v) !== -1) {
          s += WEIGHTS.style;
          matched.style.push(v);
        }
      });
    }
    if (answers.room && product.room) {
      answers.room.forEach(function (v) {
        if (product.room.indexOf(v) !== -1) {
          s += WEIGHTS.room;
          matched.room.push(v);
        }
      });
    }
    if (answers.colors && product.colors) {
      answers.colors.forEach(function (v) {
        if (product.colors.indexOf(v) !== -1) {
          s += WEIGHTS.colors;
          matched.colors.push(v);
        }
      });
    }
    if (answers.intensity && product.intensity && answers.intensity === product.intensity) {
      s += WEIGHTS.intensity;
      matched.intensity = true;
    }

    return { score: s, matched: matched };
  }

  function lowerFirst(str) {
    return str ? str.charAt(0).toLowerCase() + str.slice(1) : str;
  }

  /**
   * Construit une phrase courte et honnête à partir des critères RÉELLEMENT
   * partagés entre la demande du client et les données du produit — jamais
   * d'affirmation sur l'apparence du décor qui ne serait pas dans ses données.
   */
  function buildReason(matched) {
    var intro = matched.room.length ? ('Pour votre ' + lowerFirst(matched.room[0]) + ', ') : '';

    var parts = [];
    if (matched.style.length) {
      parts.push('son style ' + lowerFirst(matched.style[0]));
    }
    if (matched.colors.length) {
      parts.push('ses tons ' + lowerFirst(matched.colors[0]));
    }

    if (!parts.length) {
      return intro
        ? intro + 'ce décor fait partie de notre sélection et peut s\'intégrer à votre projet.'
        : 'Ce décor fait partie de notre sélection et peut s\'intégrer à votre projet.';
    }

    var subject = parts.length > 1 ? (parts[0] + ' et ' + parts[1]) : parts[0];
    var verb = parts.length > 1 ? 'correspondent' : 'correspond';
    return intro + subject + ' ' + verb + ' à votre recherche.';
  }

  /**
   * catalog : tableau de produits (voir shape injectée par Liquid).
   * answers : { room: [...], style: [...], colors: [...], intensity: '...' }
   * Retourne { results: [...top produits notés...], hasStrongMatches: bool }.
   */
  function recommend(catalog, answers, limit) {
    limit = limit || 3;
    catalog = catalog || [];

    var scored = catalog.map(function (product) {
      var result = scoreProduct(product, answers || {});
      var withScore = {};
      for (var k in product) { if (product.hasOwnProperty(k)) withScore[k] = product[k]; }
      withScore.score = result.score;
      withScore.matched = result.matched;
      withScore.reason = buildReason(result.matched);
      return withScore;
    });

    scored.sort(function (a, b) { return b.score - a.score; });

    var top = scored.slice(0, limit);
    var hasStrongMatches = top.some(function (p) { return p.score > 0; });

    return { results: top, hasStrongMatches: hasStrongMatches, catalogSize: catalog.length };
  }

  return { recommend: recommend, scoreProduct: scoreProduct };
})();
